import {
  Divider,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
} from "@mui/material";
import { ReactNode, useState } from "react";

function join<V>(
  inputs: V[],
  elementGenerator: (input: V) => ReactNode,
  divider: (idx: number) => ReactNode
): ReactNode {
  if (!inputs) {
    return <></>;
  }
  let elements = [elementGenerator(inputs[0])];
  for (let i = 1; i < inputs.length; i++) {
    elements.push(divider(i));
    elements.push(elementGenerator(inputs[i]));
  }
  return elements;
}

interface MenuItemProps {
  action: () => void;
  enabled: boolean;
  icon: ReactNode;
  title: string;
}
export function BaseMenuGroup({
  title,
  menuItems,
}: {
  title: string;
  menuItems: MenuItemProps[][];
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const handleMenuOpen = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleClick = (actionFn: () => void) => {
    return () => {
      actionFn();
      handleMenuClose();
    };
  };
  const menuItemsComponents = join(
    menuItems,
    (section) =>
      section.map((menuItem) => (
        <MenuItem
          key={menuItem.title}
          onClick={handleClick(menuItem.action)}
          disabled={!(menuItem.enabled ?? true)}
        >
          <ListItemIcon>{menuItem.icon}</ListItemIcon>
          <ListItemText>{menuItem.title}</ListItemText>
        </MenuItem>
      )),
    (idx) => <Divider key={"divider" + idx} variant="inset" component="li" />
  );

  return (
    <>
      <span onClick={handleMenuOpen}>{title}</span>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        {menuItemsComponents}
      </Menu>
    </>
  );
}
